module.exports = __webpack_public_path__ + "img/9.affaf78c.svg";